// extracted by mini-css-extract-plugin
module.exports = {"notice":"TimezoneNotice_notice__FXi9f","button":"TimezoneNotice_button__yQvQF"};